import { RefBool } from '@tblabs/truffle';


export class SelectableItem<T>
{
    public IsMarked = new RefBool(false); // for clicked item
    public IsSelected = new RefBool(false); // for Checkbox
    public Item: T;

    constructor(item: T)
    {
        this.Item = item;
    }
}
